<script>
    import {Link} from "svelte-routing";
    import {projects, researchers, videos_values} from '../data.js';

    import Video from '../Video.svelte';

    /*
    let playlist = []
    for (let k in videos_values) {
        let video = videos_values[k]
        if (video.file) {
            playlist.push({
                sources: {
                    src: "/content/videos/" + video.file,
                    type: 'video/mp4'
                },
                poster: "/content/icons/Icon_" + video.project + ".png"
            })
        }
    }
    console.log(playlist);
    */
</script>

<main>
    <div class="row">
        <h1 class="qualiperf">Virtual Tour</h1>
        <div class="row">
            <div class="col s12 m8 l8 offset-l2 offset-m2">
                <p>
                    Welcome to the video presentation of our research consortium <b>QuaLiPerF</b>.
                    We want to investigate and quantify liver perfusion-function relationship using animal
                    experiments and integrated scale-spanning models for further clinical validation.
                </p>
                <p>
                    We will introduce our research unit, the scientific projects the and service projects in
                    the corresponding videos.
                    We will present the projects as they are scientifically related and not according to the
                    P-number representing the alphabetical order of the investigators name.
                </p>
            </div>
        </div>

        {#each videos_values as video (video.id)}
            <div class="col s12 m12 l2">
                <h2 class="qualiperf">{video.id}</h2>
                <Link to="projects/{video.project}">
                    <img class="project" src="/content/icons/Icon_{video.project}.png"
                         alt="{video.project}"
                         title="{video.project} {projects[video.project].title}"/>
                </Link>
                <br/>

                <!--{projects[video.project].title}<br/>-->
                <br/>
                {#each projects[video.project].people as rid}
                    <Link to="researchers/{rid}">
                        <img src="/content/people/{rid}.png" width="70" alt="{researchers[rid].name}"
                             title="{researchers[rid].name}"/>
                    </Link>
                {/each}
            </div>
            <div class="row">
                <div class="col s12 m12 l8">
                    <Video id="{video.id}"/>
                </div>
            </div>
        {/each}
    </div>
</main>

<style>
    .box {
        min-height: 250px;
    }
</style>